module.exports = __webpack_public_path__ + "media/custom/images/img14-ed159261c2bc40b43c053a8a9c217cbc.png";